var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.required)?_c('Label',{attrs:{"icon":"mdi-card-account-details"}},[_c('v-text-field',{attrs:{"label":_vm.title,"placeholder":_vm.title,"hint":_vm.note},model:{value:(_vm.cartOrder.customer.access),callback:function ($$v) {_vm.$set(_vm.cartOrder.customer, "access", $$v)},expression:"cartOrder.customer.access"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }